import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'

const seatShape = PropTypes.shape({
  seat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rang: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
})

export default function ConfirmResetDialog({ open, seat, onConfirm, onCancel }) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth='sm'>
      <DialogTitle>Confirmation</DialogTitle>
      <DialogContent>
        <Alert severity='warning' sx={{ mb: 1 }}>
          ATTENTION: cette action supprimera toutes les informations de réservation de ce siège.
        </Alert>
        <Typography>
          Le siège {seat?.seat} (rang {seat?.rang}) deviendra disponible et toutes les données associées (réservation, info de paiement)
          seront effacées.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Annuler</Button>
        <Button onClick={onConfirm} variant='contained' color='error'>
          Confirmer
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ConfirmResetDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  seat: seatShape,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}
